module.exports = __webpack_public_path__ + "static/img/267_TO8_2358_og.3ecfc37.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/images/wedding/267_TO8_2358_og.jpg
// module id = vOFw
// module chunks = 0